import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV_LINKS, NavLink } from '../../constants';
import { BrainCircuit, Menu, X } from 'lucide-react';
import Button from '../ui/Button';
import { useAuthContext } from '../../../AuthProvider';

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { user, loading: authLoading } = useAuthContext();

  const toggleMenu = () => setIsOpen(!isOpen);

  const renderAuthButton = (isMobile = false) => {
    if (authLoading) {
      return (
        <Button to="/app" className={isMobile ? 'mt-4' : ''}>
          ...
        </Button>
      );
    }

    if (user) {
      return (
        <Button to="/app" onClick={() => isMobile && setIsOpen(false)} className={isMobile ? 'mt-4' : ''}>
          Open Canvas
        </Button>
      );
    }

    return (
      <Button to="/app" onClick={() => isMobile && setIsOpen(false)} className={isMobile ? 'mt-4' : ''}>
        Login
      </Button>
    );
  };

  return (
    <header className="sticky top-0 z-50 bg-white/70 backdrop-blur-lg border-b border-slate-900/10">
      <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center space-x-2 text-2xl font-bold text-slate-800">
          <BrainCircuit className="w-8 h-8 text-emerald-500" />
          <span>ThreadIt</span>
        </Link>

        <div className="hidden md:flex items-center space-x-8">
          {NAV_LINKS.map((link: NavLink) => (
            <Link
              key={link.name}
              to={link.href}
              className={`text-slate-600 hover:text-emerald-500 transition-colors ${
                location.pathname === link.href ? 'text-emerald-500' : ''
              }`}
            >
              {link.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:block">
          {renderAuthButton()}
        </div>

        <div className="md:hidden">
          <button onClick={toggleMenu} aria-label="Toggle menu" className="text-slate-800">
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-lg absolute w-full left-0">
          <div className="flex flex-col items-center space-y-4 py-8">
            {NAV_LINKS.map((link: NavLink) => (
              <Link
                key={link.name}
                to={link.href}
                onClick={() => setIsOpen(false)}
                className={`text-xl text-slate-600 hover:text-emerald-500 transition-colors ${
                  location.pathname === link.href ? 'text-emerald-500' : ''
                }`}
              >
                {link.name}
              </Link>
            ))}
            {renderAuthButton(true)}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;